// extracted by mini-css-extract-plugin
export default {"toolbar":"ibq5t","inner":"nu5Vf","title":"RG2Ft","textWrapper":"i1Ka2","text":"XJJpZ","dropdownIcon":"jbV7P","dropdownIconOpen":"sVsLW"};